module.exports = __webpack_public_path__ + "img/system-integration.e34fbc1f.png";